import React from "react";

import { find } from "lodash/fp";
import { useNavigate, useParams } from "react-router";

import {
  IntegrationsContent,
  IntegrationsPageContainer,
  IntegrationsSidebar,
  ScrollableContent,
  TabsContainer,
} from "@app/analytics/Integrations/styles";
import useResponsiveView from "@app/common/hooks/useResponsiveView";
import { IntegrationScope } from "@app/common/types";
import usePageTitle from "@app/utils/hooks/usePageTitle";

import Tab from "@rui/Tab";
import Tabs from "@rui/Tabs";

import { getSelectedTab, getTabs } from "./utils";

const IntegrationsList = () => {
  usePageTitle("Integrations");
  const navigate = useNavigate();
  const { scope } = useParams();
  const { inMobileView } = useResponsiveView();

  const tabs = getTabs(inMobileView);
  const { selectedTab, selectedTabConfig } = getSelectedTab(scope, tabs);

  const ContentComponent = selectedTabConfig?.content;

  const handleChangeTab = (_e: React.SyntheticEvent, tab: IntegrationScope) => {
    const path = find({ value: tab }, tabs)?.path;
    if (path) {
      navigate(path, { replace: !inMobileView });
    }
  };

  return (
    <IntegrationsPageContainer>
      <IntegrationsContent>
        <IntegrationsSidebar>
          <TabsContainer>
            <Tabs
              value={selectedTab}
              onChange={handleChangeTab}
              variant="fullWidth"
            >
              {tabs.map((tab) => (
                <Tab key={tab.value} value={tab.value} label={tab.label} />
              ))}
            </Tabs>
          </TabsContainer>
          <ScrollableContent>
            {ContentComponent && <ContentComponent />}
          </ScrollableContent>
        </IntegrationsSidebar>
      </IntegrationsContent>
    </IntegrationsPageContainer>
  );
};

export default IntegrationsList;
